<template>
  <v-container class="pa-0">
    <div class="relative" @click="focusInput">
      <input
        ref="hiddenInput"
        v-model="value"
        type="text"
        inputmode="numeric"
        autocomplete="one-time-code"
        @input="handleInput"
        class="absolute opacity-0 w-100 h-100"
      >
      
      <v-row no-gutters class="d-flex justify-center">
        <template v-for="(_, index) in numDigits">
          <v-col :key="index" cols="auto" class="mx-1">
            <v-card
              :elevation="value[index] || currentIndex === index ? 2 : 1"
              :color="value[index] || currentIndex === index ? 'green' : 'grey lighten-3'"
              class="pin-box"
              height="60"
              width="48"
            >
              <v-card-text class="d-flex justify-center align-center pa-2 text-h4">
                {{ value[index] || '' }}
              </v-card-text>
            </v-card>
          </v-col>
        </template>
      </v-row>
      <v-row no-gutters class="pt-2 d-flex justify-center" v-if="false">
        <v-col cols="auto" class="mx-1">
          Tiempo restante: {{ timer }} [seg]
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'PinInput',
  
  data() {
    return {
      value: '',
      numDigits: 6,
      currentIndex: 0,
      timer: 60
    }
  },

  methods: {
    focusInput() {
      this.$refs.hiddenInput.focus()
    },

    handleInput(e) {
      const newValue = e.target.value.replace(/[^0-9]/g, '').slice(0, this.numDigits)
      this.value = newValue
      this.currentIndex = newValue.length
      this.$emit('input', newValue)
      
      if (newValue.length === this.numDigits) {
        this.$emit('complete', newValue)
        console.log('complete')
      }
    },

    startTimer() {
      this.timer = 60
      const timer = setInterval(() => {
        if (this.timer === 0) {
          clearInterval(timer)
          this.timer = 60
          return
        }
        this.timer--
      }, 1000)
    },

    setTimer() {
      this.timer = 60
    }
  },

  mounted() {
    this.startTimer()
  }
}
</script>

<style scoped>
.relative {
  position: relative;
}

.absolute {
  position: absolute;
  top: 0;
  left: 0;
}

.opacity-0 {
  opacity: 0;
}

.w-100 {
  width: 100%;
}

.h-100 {
  height: 100%;
}

.pin-box {
  min-width: 48px;
}
</style>
